import React from 'react';
import {
  ErrorBoundaryState,
  RRNLRequestErrorWithExtensions,
} from '@sparknz/journeys-common';

export function checkIsAuthError(error: Error) {
  const hasAuthError = (
    error as RRNLRequestErrorWithExtensions
  )?.res?.errors?.find(({ message }) => {
    return message.match(/401: Unauthorized/i);
  });

  return Boolean(error?.name === 'RRNLRequestError' && hasAuthError);
}

interface ErrorBoundaryProps {
  fallback: React.ReactNode;
  children: React.ReactNode;
}

class NonLoggedInUserErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = {
      error: null,
    };
  }

  public static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    // Update state so the next render will show the fallback UI.
    return { error };
  }

  componentDidCatch() {
    // displays the actual error in the console, to get a clear fail fast feedback
    // eslint-disable-next-line no-console
    console.warn('Unauthorised user, login is required.');
  }

  public render() {
    const { error } = this.state;
    const { fallback: Fallback, children } = this.props;

    if (checkIsAuthError(error)) {
      return <div data-testid="auth-error-boundary-fallback">{Fallback}</div>;
    }

    return children;
  }
}

export default NonLoggedInUserErrorBoundary;
